import React, { useEffect } from "react";
import { Link} from 'react-router-dom';
import ScrollReveal from "scrollreveal";
import "./CV.css"; // Asegúrate de que los estilos estén en este archivo
import {  Button } from "@mui/material";


const LandingPostulantes = () => {
  useEffect(() => {
    const sr = ScrollReveal({
      origin: "top", // Dirección de aparición
      distance: "80px", // Distancia del efecto
      duration: 2000, // Duración de la animación
      reset: true, // Hace que el efecto se repita al hacer scroll
    });

    // Aplicar efecto a cada elemento con su respectiva clase
    sr.reveal(".home-title", {});
    sr.reveal(".button", { delay: 200 });
    sr.reveal(".home-img", { delay: 400 });
    sr.reveal(".home-social", { delay: 400 });

    sr.reveal(".about-img", {});
    sr.reveal(".about-subtitle", { delay: 200 });
    sr.reveal(".about-text", { delay: 400 });

    sr.reveal(".skills-subtitle", { delay: 100 });
    sr.reveal(".skills-text", { delay: 150 });
    sr.reveal(".skills-data", { interval: 200 });
    sr.reveal(".skills-img", { delay: 400 });

    sr.reveal(".work-img", { interval: 200 });

    sr.reveal(".contact-input", { interval: 200 });
  }, []);

  return (
    <main className="l-main">
      {/* Sección de Inicio */}
      <section className="home bd-grid" id="home">
        <div className="home-data">
          <h1 className="home-title">
            Hola, <br />soy <span className="home-title-color">Juan</span>
            <br /> Diseñador Web
          </h1>
        </div>

        <div className="home-img">
          <img src="https://i.postimg.cc/65sT6Z3M/perfil.png" alt="image" />
        </div>
        <h3 className="h3Home">
            Tene un cv asi como este vos tambíen y destacá
        </h3>
      </section>

      {/* Sección About */}
      <section className="about section" id="about">
        <h2 className="section-title">Sobre mi</h2>
        <div className="about-container bd-grid">
          <div className="about-img">
            <img src="https://i.postimg.cc/NjdgX2sq/about.jpg" alt="image" />
          </div>
          <div>
            <h2 className="about-subtitle">Somos Apimys</h2>
            <p className="about-text">
            Vos también podés tener un currículum impactante como este en solo minutos. Registrate ahora, completá tus datos y destacate frente a las mejores oportunidades. Es fácil, rápido y completamente gratis. ¡No dejes pasar la chance de potenciar tu carrera!
            </p>
          </div>
        </div>
      </section>

      {/* Sección Skills */}
      <section className="skills section" id="skills">
        <h2 className="section-title">Habilidades</h2>
        <div className="skills-container bd-grid">
          <div className="conteinerTextoSill">
            <p className="skills-text">
              Estás son algunas de las cosas que hacemos por vos.
            </p>
            <div class="skills-data">
                <div class="skills-names">
                    <span class="skills-name">Analzizar tu cv</span>
                </div>
                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>

            <div class="skills-data">
                <div class="skills-names">
                    <span class="skills-name">Presentarlo a empresas</span>
                </div>
                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>

            <div class="skills-data">
                <div class="skills-names">
                    <i class='bx bxl-javascript skills-icon' ></i>
                    <span class="skills-name">Mostrarte vacantes</span>
                </div>

                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>

            <div class="skills-data">
                <div class="skills-names">
                    <i class='bx bxs-paint skills-icon' ></i>
                    <span class="skills-name">Postulaciones fáciles</span>
                </div>

                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>
          </div>
          <div className="conteinerImgSkill">
            <img src="https://i.postimg.cc/52LWbPyt/work3.jpg" alt="image" className="skills-img" />
          </div>
        </div>
      </section>

      {/* Sección Work */}
      <section className="work section" id="work">
        <h2 className="section-title">Trabajos</h2>
        <div className="work-container bd-grid">
            <div className="work-img">
              <h3>Crea tu Currículum en Video</h3>
              <p>Haz tu currículum en formato video, una forma innovadora de destacarte ante los reclutadores.</p>
            </div>   
            <div className="work-img">
              <h3>Comparte en Redes Sociales</h3>
              <p>Comparte tu Apimys curriculum en tus redes sociales y llega a más personas con tu talento.</p>
            </div>   
            <div className="work-img">
              <h3>¡Premios a los Mejores!</h3>
              <p>Participa en sorteos y premios por tener el currículum más creativo. ¡Incentivos reales para ti!</p>
            </div>   
        </div>
      </section>

      {/* Sección Contact */}
      <section className="contact section" id="contact">
        <h2 className="section-title">Se parte</h2>
        <div className="contact-container bd-grid">
        <p className="skills-text">Vos podes tener un curriculum como este y destacar. ¡Registrate gratis ahora!</p>
        <Link to="/Register"><Button variant="contained" sx={{ backgroundColor: "#007bff", "&:hover": { backgroundColor: "#0056b3" } }} size="large">
          ¡Únete Ahora!
        </Button></Link>
        </div>
      </section>
    </main>
  );
};

export default LandingPostulantes;
